module.exports = __webpack_public_path__ + "src/assets/games/34/TUBES018.jpg";